import API from '@/services/endpoint'
import { FETCH_UPCOMING_EVENTS } from "../../mutation-types";

/**
 * API Get Request to fetch the upcoming events
 * @param {function} commit - The vuex commit function
 * @param {object} state - The vuex state object
 * @return {object[]} A array of upcoming events
 */
export async function fetchUpcomingEvents({commit, state}) {
  try {
    const { url } = state;
    let responseObj = await API.get(url);
    let { data: { message } } = responseObj;
    
    // Handle different response structures
    let events = [];
    if (message && message.events) {
      events = message.events;
    } else if (Array.isArray(message)) {
      events = message;
    }
    
    // Take only the first 3 events
    const upcomingEvents = events.slice(0, 3);
    commit(FETCH_UPCOMING_EVENTS, upcomingEvents)
  } catch (error) {
    console.error('Error fetching upcoming events:', error);
    commit(FETCH_UPCOMING_EVENTS, [])
  }
}


